/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "helpers/Spinner";

import { import_current_tab, import_set_data, import_success_import, import_reset_tab } from './store'
import LanguageHelper from 'helpers/language_helper'

class ImportFileStep3 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    activeModalRecurso: false,
    selResource: -1,
    selSubLineaTem: -1,
    listResources: []
  }
  constructor (props) {
    super(props)
    console.log('Constructo step3')

  }
  componentDidUpdate (props, state) {
    console.log('update import step 3', this, state, this.state)
    console.log('update import step 3', props, this.props)
   
  }
  
  componentDidMount () {
    console.log('mounted step3', this.state, this.props)
    // this.props.import_set_data({resource: 999999})
  }
  disabledProcesar = () => {
    return true;
  }
  
  OnClick_nuevo = (evt) => {
    Spinner.show()
    this.props.import_reset_tab();
 
  }

  downloadTxtFile = () => {
    const element = document.createElement("a");
    const messageErrors=this.props.importProcesado.listErrors;
    let listItems = messageErrors.map((number) =>
          `Error en la fila: ${number.key+1}. Error: ${number.errors.iva_val_value!=null ? number.errors.iva_val_value:''} ${number.errors.iva_int_year!=null ? number.errors.iva_int_year:'' } ${number.errors.cou_int_id!=null ? number.errors.cou_int_id:''} \n`
        );
    let messStrErr="";
    listItems.map((number) =>
          messStrErr=messStrErr+number
        );

    const file = new Blob([messStrErr], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = "errores.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  onSubmit_Step4 = (event) => {
    event.preventDefault()
       
  }
  
  render () {
    return (
      <div id={ this.props.id } className={this.props.className}>
      
        <form id="frmImportStep3" onSubmit={ this.onSubmit_Step4 }>
        
          <div className="field ">

            <p className="card-header-title">
              <span className="icon"><i className="mdi mdi-finance"></i></span>
              {LanguageHelper.getLanguageString('ImportIndicators3.indicator')}: {this.props.importData.typeInformationName}
            </p>
            <p className="card-header-title">
              <span className="icon"><i className="mdi mdi-finance"></i></span>
              {LanguageHelper.getLanguageString('ImportIndicators3.file')}: {this.props.importData.fileName}
            </p>
           </div> 

          <hr />
          <div className="field center">
          <h2><b>{LanguageHelper.getLanguageString('ImportIndicators3.messageProcess')} {this.props.importProcesado.registros} {LanguageHelper.getLanguageString('ImportIndicators3.messageProcessReg')}</b></h2>
          <h2><b><i className="fas fa-check-circle"></i> {this.props.importProcesado.successRow} {LanguageHelper.getLanguageString('ImportIndicators3.messageRegSuc')}</b></h2>
          <h2><b><i className="fas fa-times-circle"></i> {this.props.importProcesado.failRow} {LanguageHelper.getLanguageString('ImportIndicators3.messageRegErr')}</b></h2>
          {this.props.importProcesado.haveError ?
          <button onClick={this.downloadTxtFile}>{LanguageHelper.getLanguageString('ImportIndicators3.messageDowReg')}</button>
          :""}
          </div>
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">
                      <div className="control">
                        <button type="button" className="button is-primary" >
                          <a  onClick={this.OnClick_nuevo} href="/intranetIndicators/importFile" style={{color:'white'}}>{LanguageHelper.getLanguageString('ImportIndicators3.submit')} </a>
                        </button></div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

            </div>
          
        </form>
     
      </div>
    )
  }
}

const mapStateToProps = (state, props /*, ownProps*/) => {
  console.log('mapStateToProps import2',state)
    return {
      currentTab: state.reducerTab.tab,
      importData: state.reducerData,
      importProcesado: state.reducerProcesar,
      tableStructure: state.reducerData.table.structure,

    }
  }
export default connect(mapStateToProps, {
  import_current_tab,
  import_reset_tab,
  import_set_data,  
  import_success_import,
  import_set_column: (data) => {
    return {
      type: 'IMPORT_UPDATE_STRUCTURE',
      payload: data
    }
  }
})(ImportFileStep3)